const rebuyTrigger = document.querySelector('.rebuy-trigger');
const inlineSearchForm = document.querySelector('.inline-search-form');

rebuyTrigger.addEventListener('click', (event) => {
    if (window.innerWidth <= 768) { // Check if the device width is 768px or less (mobile devices)
        inlineSearchForm.classList.add('mobile-inline-search-form');
        
        // Prevent the click event from propagating to the document
        event.stopPropagation();

        // Add event listener to the document to close the form when clicking outside
        document.addEventListener('click', (event) => {
            if (!inlineSearchForm.contains(event.target) && !rebuyTrigger.contains(event.target)) {
                inlineSearchForm.classList.remove('mobile-inline-search-form');
            }
        }, { once: true });
    }
});

// Prevent clicks inside the inlineSearchForm from propagating to the document
inlineSearchForm.addEventListener('click', (event) => {
    event.stopPropagation();
});